import { differenceDeep } from "../../utils/difference.js";
import { deepCopy, findKeyInObject } from "../../utils/object-utils.js";
import { uuid } from "../../utils/uuid.js";
import { isEmpty } from "lodash-es";
import { translit } from "../../utils/transliterate.js";
import { ref, computed, unref } from "vue";
import { CulturesArray } from "./Cultures.js";
import { useApolloGlobalClient } from "../../plugins/apollo.js";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import { useBanza } from "../../plugins/banza/global.js";
import "axios";
import "vue-router";
import { useI18n } from "../../plugins/i18n.js";
import "maska";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "../../assets/e94e4817134d7c25.png";
import "../../assets/5341da3ffbec0137.png";
import "../../assets/01f50022317dccd7.png";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css                     */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                               */
import "vuetify/components/VGrid";
import "../Base/index.js";
import "moment";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                      */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                        */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import "../../graphql/system-settings.js";
import "tiny-emitter/instance";
/* empty css                             */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                            */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                                             */
/* empty css                          */
import "graphql-tag";
import "../../graphql/entity.js";
import "../../graphql/lookups.js";
/* empty css                       */
import "vuetify/components";
/* empty css                             */
/* empty css                     */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                         */
import "vuetify/components/VTooltip";
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
/* empty css                            */
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
/* empty css                        */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                           */
/* empty css                               */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                  */
import "vuetify/components/VItemGroup";
/* empty css                             */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                        */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
const useMultilingualContent = ({
  itemCode,
  loadQuery,
  saveQuery,
  savedCallback,
  savedMessageLcz
} = {}) => {
  const banza = useBanza();
  const client = useApolloGlobalClient();
  const { locale, availableLocales, t } = useI18n();
  const initialData = ref([]);
  const items = ref([]);
  const isNew = ref(!itemCode);
  const isLoading = ref(false);
  const diff = computed(() => differenceDeep(items.value, initialData.value));
  const hasChanges = computed(() => !isEmpty(diff.value));
  const avalibleCulturesArray = computed(
    () => CulturesArray.filter((c) => availableLocales.includes(c.code)) || []
  );
  const avalibleCultures = computed(
    () => avalibleCulturesArray.value.filter((c) => !getItemByCulture(c.id))
  );
  const usedCultures = computed(
    () => avalibleCulturesArray.value.reduce((acc, c) => {
      const item = getItemByCulture(c.id);
      if (item) {
        acc.push({
          ...c,
          item
        });
      }
      return acc;
    }, [])
  );
  const getCummonColumn = (column) => {
    var _a;
    const value = (_a = items.value[0]) == null ? void 0 : _a[column];
    return value;
  };
  const changeCummonColumn = (column, value) => {
    items.value = items.value.map((i) => ({
      ...i,
      [column]: value
    }));
  };
  const defineCommonColumn = (column, options) => computed({
    get: () => getCummonColumn(column),
    set: (value) => changeCummonColumn(column, value),
    ...options
  });
  const code = defineCommonColumn("code", {
    set(value) {
      changeCummonColumn("code", translit(value));
    }
  });
  const addCulture = (cultureId) => {
    items.value.push({
      id: uuid(),
      culture: { id: cultureId },
      code: code.value
    });
  };
  const removeCulture = (cultureId) => {
    const item = getItemByCulture(cultureId);
    if (item) {
      item.isDeleted = true;
    }
  };
  const getItemByCulture = (cultureId) => items.value.find((i) => i.culture.id === cultureId && !i.isDeleted);
  const getItemCulture = (itemId) => {
    var _a;
    return (_a = items.value.find((i) => i.id === itemId)) == null ? void 0 : _a.culture;
  };
  const generateCodeByItem = (item) => {
    const currentTitle = item == null ? void 0 : item.title;
    if (!currentTitle) {
      return;
    }
    code.value = translit(currentTitle);
  };
  const load = async () => {
    if (isNew.value) {
      const appLocale = CulturesArray.find(
        (c) => c.code === unref(locale)
      );
      addCulture(appLocale.id);
      initialData.value = deepCopy(items.value);
    } else {
      const { data } = await client.query({
        query: loadQuery,
        variables: {
          where: {
            code: {
              eq_ci: itemCode
            }
          }
        }
      });
      const value = findKeyInObject(data, "items") || [];
      initialData.value = deepCopy(value);
      items.value = deepCopy(value);
    }
  };
  const save = async () => {
    isLoading.value = true;
    client.mutate({
      mutation: saveQuery,
      variables: {
        inputs: !isEmpty(diff.value) ? diff.value.map((i) => ({
          ...i,
          code: code.value,
          culture: getItemCulture(i.id)
        })) : []
      }
    }).then(({ data }) => {
      const error = data == null ? void 0 : data.result;
      if (error) {
        banza.showGlobalMessage(error, "error");
        return;
      }
      if (isNew.value) {
        banza.showGlobalMessage(
          t(savedMessageLcz || "pages.card.messages.created"),
          "success",
          savedCallback
        );
      } else {
        initialData.value = deepCopy(items.value);
        savedCallback();
      }
    }).catch((error) => {
      banza.showGlobalMessage(
        t("errors.base.record_save_failed"),
        "error"
      );
      console.log(error);
    }).finally(() => {
      isLoading.value = false;
    });
  };
  const reset = () => {
    items.value = deepCopy(initialData.value);
  };
  return {
    items,
    isNew,
    isLoading,
    hasChanges,
    load,
    save,
    reset,
    avalibleCultures,
    usedCultures,
    addCulture,
    removeCulture,
    code,
    generateCodeByItem,
    defineCommonColumn
  };
};
export {
  useMultilingualContent
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
